/**
 * 严肃声明：
 * 开源版本请务必保留此注释头信息，若删除我方将保留所有法律责任追究！
 * 本系统已申请软件著作权，受国家版权局知识产权以及国家计算机软件著作权保护！
 * 可正常分享和学习源码，不得用于违法犯罪活动，违者必究！
 * Copyright (c) 2020 陈尼克 all rights reserved.
 * 版权所有，侵权必究！
 */

import axios from '../utils/axios'

export function getUserTaxNo() {
  return axios.get('/invoice/getUserTaxNo');
}
export function getTaxNoByCompanyName(params) {
  return axios.get('/invoice/getTaxNoByCompanyName', {
    params
  });
}

//关联商品
export function InvoiceOrderItem(id) {
  return axios.get(`/invoice/InvoiceOrderItem/${id}`);
}

//红冲重开
export function redInvoice(id) {
  return axios.put(`/invoice/redInvoice/${id}`);
}


export function getuserinvoice(params) {
  return axios.get('/order/invoice', {params});
}

export function invoice(params) {
  return axios.post('/invoice', params);
}


export function getinvoice(params) {
  return axios.get('/invoice',{params});
}

export function EditAddress(params) {
  return axios.put('/address', params);
}

export function DeleteAddress(id) {
  return axios.delete(`/address/${id}`);
}

export function getAddressList() {
  return axios.get('/address', {
    pageNumber: 1,
    pageSize: 1000
  })
}

export function getAddressDetail(id) {
  return axios.get(`/address/${id}`)
}